import * as React from 'react';
import { connect } from 'react-redux';
import * as Core from 'components/core';
import { AppState } from 'app/store';
import { RemoteData } from 'app/store/remoteData';
type PropsFromAppState = {
  enabled: RemoteData<boolean>;
  apiIsAvailable: boolean | undefined | null;
};
type Props = {
  recaptchaID: string;
  children: React$Node;
  bypass: boolean;
} & PropsFromAppState;
function mapAppStateToProps(appState: AppState): PropsFromAppState {
  return {
    apiIsAvailable: appState.recaptcha.apiIsAvailable,
    enabled: appState.recaptcha.enabled,
  };
}

/*
NB: this component currently only waits for recaptcha to be initialized
before rendering its children, but the way the recaptcha token creation is
implemented, waiting for recaptcha to be initialized before rendering
recaptcha-depending UI elements isn't strictly necessary.

However, recaptcha-dependent UI should still be wrapped in this component, to
ease migration in case we decide to use checkbox recaptcha. This component
serves as a marker and placeholder for where we would need to add the "I'm not
a robot" widgets.
*/
class ProtectedByRecaptcha extends React.Component<Props> {
  static defaultProps = {
    bypass: false,
  };
  render() {
    const { bypass, enabled, apiIsAvailable, children } = this.props;

    // e.g. for checkout UIs where the cart is an invoice
    if (bypass) {
      return children;
    }
    const enableReCAPTCHA = enabled.value;
    if (apiIsAvailable == null) {
      return <Core.ActivityIndicator />;
    }
    if (enableReCAPTCHA && !apiIsAvailable) {
      // go ahead and render. attempts to use a protected action without the recaptcha API loaded will send honeybadger reports
      return children;
    }
    if (enableReCAPTCHA == null) {
      return <Core.ActivityIndicator />;
    }
    return children;
  }
}
export default connect(mapAppStateToProps)(ProtectedByRecaptcha);
